export default __webpack_public_path__ + "static/semicircleimageDark-6e2f06d3319023a243f5d1a8464df55e.png";